import { PRESETS } from "@rally/agreed";
import { Chip, Col, Row, Text, Textarea, useTheme } from "@rally/ui-kit";
import { say } from "../localization/say.ts";

export function BriefingField({
  value,
  onChange,
  onPreset,
  rows = 5,
  testID = "agent-definition",
}: {
  value: string;
  onChange: (next: string) => void;
  onPreset?: (name: string) => void;
  rows?: number;
  testID?: string;
}) {
  const theme = useTheme();
  return (
    <Col style={{ gap: theme.space[2] }}>
      <Text typeName="caption" color="text.secondary">
        {say("agents.definition")}
      </Text>
      <Row gap={2} wrap>
        {PRESETS.map((preset) => (
          <Chip
            key={preset.name}
            size="sm"
            muted={value !== preset.briefs}
            testID={`agent-preset-${preset.name}`}
            onPress={() => {
              onChange(preset.briefs);
              onPreset?.(preset.name);
            }}
          >
            {preset.name}
          </Chip>
        ))}
      </Row>
      <Textarea
        value={value}
        onChangeText={onChange}
        rows={rows}
        placeholder={say("agents.definitionHint")}
        testID={testID}
      />
    </Col>
  );
}
